import { $t } from '@/i18n';
import { get } from 'lodash';
import exportExcel, { exportExcels, getFieldsArray } from '@utils/export-excel';
import importExcel from '@utils/import-excel';
import { useFileDialog } from '@vueuse/core';
import { XyExcelFieldConfigMeta, XyExcelEditMeta } from '../paramsFormComponents';
import logger from '@/utils/logger';
import { CATEGORY } from './const';
import { exportCsv } from '@/utils/export-csv';
// Excel导出
export const exportExcelAtom = {
    id: 'xy:exportExcel',
    name: $t('k_13a8199d'),
    desc: $t('k_8def6363'),
    category: CATEGORY.EXPORT,
    paramsSchema: {
        type: 'object',
        ui: {
            type: 'XyExcelEdit',
        },
        fields: [
            {
                id: 'jsCode',
                type: 'string',
                title: $t('k_eeaec374'),
                description: $t('k_8de077c8'),
                ui: {
                    type: 'exprInput',
                    props: {
                        type: 'javascript',
                        multipleLine: true,
                        placeholder: $t('k_8de077c8'),
                    },
                },
            },
            {
                id: 'mode',
                type: 'array',
                title: $t('k_2effff72'),
                default: 'form',
            },
            {
                id: 'fieldConfig',
                type: 'array',
                title: $t('k_19de9bca'),
                default: [],
                // ui: {
                //   type: 'XyExcelFieldConfigEdit',
                // },
            },
            {
                id: 'fieldConfigJsCode',
                type: 'string',
                title: $t('k_c7c908fe'),
                default: '',
            },
            {
                id: 'fileName',
                type: 'string',
                title: $t('k_4b3c20e6'),
                default: 'excel',
            },
            {
                id: 'sheetName',
                type: 'string',
                title: $t('k_68e3ed73'),
                default: 'Sheet1',
            },
            {
                id: 'format',
                title: $t('k_f896aba3'),
                type: 'string',
                enum: [
                    { label: 'xlsx', value: 'xlsx' },
                    { label: 'xlsm', value: 'xlsm' },
                    { label: 'csv', value: 'csv' },
                ],
                default: 'xlsx',
            },
        ],
    },
    paramsFormComponents: [XyExcelFieldConfigMeta, XyExcelEditMeta],
    async execute(ctx, params) {
        const { type = 'single', sheetJsCode, jsCode, fileName, sheetName, format, fieldConfig, mode, fieldConfigJsCode } = params;
        const rtx = get(ctx, 'renderer')?.wContext?.user?.rtx || '';
        if (type === 'multiple') {
            if (format === 'csv') {
                throw new Error($t('k_93910646'));
            }
            const sheets = ctx.tryEval(sheetJsCode);
            await exportExcels(sheets, {
                author: rtx,
                fileName,
                format,
            }, () => {
                logger.info($t('k_e15c599f'));
            });
            return;
        }
        const data = ctx.tryEval(jsCode);
        if (!Array.isArray(data)) {
            throw new Error($t('k_bcc6464'));
        }
        let fields = [];
        if (mode === 'js') {
            fields = ctx.tryEval(fieldConfigJsCode);
        }
        else {
            // 老数据是空的，兼容
            fields = fieldConfig;
        }
        if (!fields?.length) {
            throw new Error($t('k_b75e711d'));
        }
        try {
            if (format === 'csv') {
                const newData = getFieldsArray(data, fields);
                await exportCsv(newData, { columns: fields.map(item => item.colName), fileName: `${fileName}.csv` });
            }
            else {
                await exportExcel(data, {
                    author: rtx,
                    fileName,
                    sheetName,
                    format,
                    fields,
                }, () => {
                    logger.info($t('k_e15c599f'));
                });
            }
        }
        catch (e) {
            throw new Error($t('k_2e2bfd56', { arg_0: e.message }));
        }
    },
};
// Excel导入
export const importExcelAtom = {
    id: 'xy:importExcel',
    name: $t('k_ffb2cb19'),
    desc: $t('k_fc362b96'),
    category: CATEGORY.EXPORT,
    paramsSchema: {
        type: 'object',
        fields: [
            {
                id: 'raw',
                type: 'boolean',
                title: $t('k_558e2802'),
                default: false,
            },
            {
                id: 'cellDates',
                type: 'boolean',
                title: $t('k_3c1ac1e4'),
                default: true,
            },
            {
                id: 'codepage',
                type: 'string',
                title: $t('k_a07ade'),
                enum: [
                    {
                        label: $t('k_1a462199'),
                        value: '',
                    },
                    {
                        label: 'UTF-8',
                        value: '65001',
                    },
                    {
                        label: 'GBK / GB2312',
                        value: '936',
                    },
                ],
                default: '',
            },
        ],
    },
    execute: async (ctx, params) => {
        const { raw = false, cellDates = true, codepage } = params;
        const result = await new Promise((rs, rj) => {
            const { open, onCancel, onChange } = useFileDialog({
                accept: '.xlsx, .xls, .csv',
            });
            onChange((files) => {
                if (!files?.length)
                    rs(null);
                const [file] = files;
                if (ctx?.state)
                    ctx.state.__file__ = file;
                const reader = new FileReader();
                reader.onload = async (e) => {
                    try {
                        const data = e?.target?.result;
                        const option = { raw, cellDates };
                        if (codepage)
                            option.codepage = parseInt(codepage, 10);
                        const excelData = await importExcel(data, option);
                        rs(excelData);
                    }
                    catch (e) {
                        rj(e);
                    }
                };
                reader.onerror = (e) => {
                    rj(e);
                };
                reader.readAsBinaryString(file);
            });
            onCancel(() => rs(null));
            open();
        });
        return result;
    },
    returnValue: {
        type: 'object',
        fields: [{
                id: '[filename]',
                type: 'array',
                description: $t('k_9d343e75'),
                items: {
                    type: 'any',
                    description: $t('k_ab2fd52'),
                },
            }],
        description: $t('k_675524a'),
    },
};
export default [
    exportExcelAtom,
    importExcelAtom,
];
